'use client'

import { StateCreator } from 'zustand'
import { type StoreState } from '.'

export type ViewMode = 'card' | 'list'

export interface ViewPreferences {
  eLendViewMode: ViewMode
  setELendViewMode: (mode: ViewMode) => void
  eBorrowViewMode: ViewMode
  setEBorrowViewMode: (mode: ViewMode) => void
  eVaultViewMode: ViewMode
  setEVaultViewMode: (mode: ViewMode) => void
  pooledViewMode: ViewMode
  setPooledViewMode: (mode: ViewMode) => void
  legacyViewMode: ViewMode
  setLegacyViewMode: (mode: ViewMode) => void
}

export interface ViewPreferencesSlice {
  viewPreferences: ViewPreferences
}

// Default to card view
const DEFAULT_VIEW_MODE: ViewMode = 'card'

export const initViewPreferencesSlice: StateCreator<StoreState, [], [], ViewPreferencesSlice> = (set) => ({
  viewPreferences: {
    eLendViewMode: DEFAULT_VIEW_MODE,
    setELendViewMode: (mode: ViewMode) =>
      set((state) => ({ viewPreferences: { ...state.viewPreferences, eLendViewMode: mode } })),
    eBorrowViewMode: DEFAULT_VIEW_MODE,
    setEBorrowViewMode: (mode: ViewMode) =>
      set((state) => ({ viewPreferences: { ...state.viewPreferences, eBorrowViewMode: mode } })),
    eVaultViewMode: DEFAULT_VIEW_MODE,
    setEVaultViewMode: (mode: ViewMode) =>
      set((state) => ({ viewPreferences: { ...state.viewPreferences, eVaultViewMode: mode } })),
    pooledViewMode: DEFAULT_VIEW_MODE,
    setPooledViewMode: (mode: ViewMode) =>
      set((state) => ({ viewPreferences: { ...state.viewPreferences, pooledViewMode: mode } })),
    legacyViewMode: DEFAULT_VIEW_MODE,
    setLegacyViewMode: (mode: ViewMode) =>
      set((state) => ({ viewPreferences: { ...state.viewPreferences, legacyViewMode: mode } })),
  },
})

export interface PersistedViewPreferencesSlice {
  viewPreferences: {
    eLendViewMode: ViewMode
    eBorrowViewMode: ViewMode
    eVaultViewMode: ViewMode
    pooledViewMode: ViewMode
    legacyViewMode: ViewMode
  }
}

export function persistViewPreferencesSlice(state: StoreState): PersistedViewPreferencesSlice {
  return {
    viewPreferences: {
      eLendViewMode: state.viewPreferences.eLendViewMode,
      eBorrowViewMode: state.viewPreferences.eBorrowViewMode,
      eVaultViewMode: state.viewPreferences.eVaultViewMode,
      pooledViewMode: state.viewPreferences.pooledViewMode,
      legacyViewMode: state.viewPreferences.legacyViewMode,
    },
  }
}
